import { render } from "./GridTabParteneriComercial.vue?vue&type=template&id=5e53663f&scoped=true&ts=true"
import script from "./GridTabParteneriComercial.vue?vue&type=script&lang=ts"
export * from "./GridTabParteneriComercial.vue?vue&type=script&lang=ts"

import "./GridTabParteneriComercial.vue?vue&type=style&index=0&id=5e53663f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e53663f"]])

export default __exports__